/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonContingentInfo
 */
export interface JsonContingentInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonContingentInfo
     */
    allowedActions?: Array<JsonContingentInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    contingentId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingentInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingentInfo
     */
    dayDate?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    dayNo?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingentInfo
     */
    owner?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    partyCnt?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingentInfo
     */
    siwiId?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    siwiUsed?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingentInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingentInfo
     */
    updatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingentInfo
     */
    zone?: string;
}

/**
* @export
* @enum {string}
*/
export enum JsonContingentInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}

export function JsonContingentInfoFromJSON(json: any): JsonContingentInfo {
    return JsonContingentInfoFromJSONTyped(json, false);
}

export function JsonContingentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonContingentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'contingentId': !exists(json, 'contingentId') ? undefined : json['contingentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'dayDate': !exists(json, 'dayDate') ? undefined : json['dayDate'],
        'dayNo': !exists(json, 'dayNo') ? undefined : json['dayNo'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'partyCnt': !exists(json, 'partyCnt') ? undefined : json['partyCnt'],
        'siwiId': !exists(json, 'siwiId') ? undefined : json['siwiId'],
        'siwiUsed': !exists(json, 'siwiUsed') ? undefined : json['siwiUsed'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'zone': !exists(json, 'zone') ? undefined : json['zone'],
    };
}

export function JsonContingentInfoToJSON(value?: JsonContingentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'contingentId': value.contingentId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'dayDate': value.dayDate,
        'dayNo': value.dayNo,
        'eventId': value.eventId,
        'limit': value.limit,
        'owner': value.owner,
        'partyCnt': value.partyCnt,
        'siwiId': value.siwiId,
        'siwiUsed': value.siwiUsed,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'zone': value.zone,
    };
}

